<template>
  <span>
    <v-btn
      color="primary"
      :disabled="delayImport"
      :loading="saveloading"
      outline
      @click="onClickUploadButton"
    >
      <i class="fas fa-file-import"></i>
      &nbsp;
      {{ $t('import') }}
    </v-btn>
    <input
      type="file"
      :key="countkey"
      class="form-control-file pt-2"
      name="csvUpload"
      :id="'csvUpload'"
      data-vv-as="File"
      v-validate="'mimes:text/xlsx'"
      accept=".xlsx"
      @input="onFileChange($event)"
      style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
    />
  </span>
</template>

<script>
import parser from 'simple-excel-to-json'
import XLSX from 'xlsx'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      delayImport: false,
      saveloading: false,
      countkey: 1,
      allit: [
        'Database Management',
        'IT & Technical Support',
        'IT Management',
        'IT อื่นๆ',
        'Network & System',
        'Programmer & Developer',
        'SAP & ERP',
        'Website',
      ],
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
  },
  methods: {
    onClickUploadButton() {
      document.getElementById('csvUpload').click()
    },
    onFileChange(event) {
      let vm = this
      vm.loading = true
      let files = event.target.files || event.dataTransfer.files
      var myFile = files[0]
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array' })

        /* DO SOMETHING WITH workbook HERE */
        var result = []
        for (var sheet in workbook.Sheets) {
          result.push(vm.trimObj(XLSX.utils.sheet_to_json(workbook.Sheets[sheet])))
        }

        vm.uploadExcel(result)
      }
      reader.readAsArrayBuffer(myFile)
      this.countkey++
    },
    trimObj(obj) {
      var vm = this
      if (!Array.isArray(obj) && typeof obj != 'object') return obj
      return Object.keys(obj).reduce(
        function (acc, key) {
          acc[key.trim()] = typeof obj[key] == 'string' ? obj[key].trim() : vm.trimObj(obj[key])
          return acc
        },
        Array.isArray(obj) ? [] : {}
      )
    },

    uploadExcel(file) {
      var vm = this
      // var productlength = 0
      // file[1].map((el) => {
      //   var op1 = el.Option1Detail ? el.Option1Detail.split(',').length : 0
      //   var op2 = el.Option2Detail ? el.Option2Detail.split(',').length : 0
      //   if (op2) {
      //     productlength += op1 * op2
      //   } else productlength += op1
      // })
      if (true) {
        var data = file[0].map((el) => {
          var Category = ''
          if (this.allit.includes(el['หมวดหมู่งาน'])) {
            Category = 'it'
          } else {
            Category = 'non-it'
          }
          return {
            Logo: el['ลิงค์รูป Logo'],
            Name: el['ชื่อบริษัท'],
            Profile: el['โปรไฟล์'],
            Address: el['ที่อยู่'],
            Website: el['เว็บไซต์'],
            Province: el['จังหวัด'],
            Lat: el['Lat'],
            Long: el['Long'],
            Part_Full: el['รูปแบบการจ้าง'],
            Type: el['หมวดหมู่งาน'],
            Quantity: el['จำนวนที่รับ'],
            Qualifications: el['คุณสมบัติ'],
            Requirements: el['ความต้องการ'],
            Skills: el['ทักษะ'],
            Salary: el['เงินเดือน'],
            Benefits: el['ผลประโยชน์'],
            Contact: '',
            Apply_email: el['อีเมลสำหรับยื่นใบสมัคร'],
            Apply_website: el['เว็บไซต์สำหรับยื่นใบสมัคร'],
            Position: el['ตำแหน่ง'],
            Details: el['รายละเอียดงาน'],
            Category: Category,
          }
        })

        this.onCreateData(data)
      }
    },
    onCreateData(data) {
      this.saveloading = true
      api.postdepajobd2uadmincreatejob({ jobdata: data }, (err, response) => {
        this.saveloading = false
        this.$emit('createData')
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/jobd2u/ImportJob.vue